/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";

const LpDivorceAdvoCardMeta = () => {
  const title = "Scheidung einreichen | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Reichen Sie als ADVOCARD Kunde Ihre Scheidung online ein - schnell, einfach und nirgendwo günstiger!" />
      <meta name="keywords" content="Advocard, Scheidung, Scheidung online, Scheidung einreichen, scheiden lassen, Scheidungskosten" />
      <meta name="robots" content="noindex,nofollow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Reichen Sie als ADVOCARD Kunde Ihre Scheidung online ein - schnell, einfach und nirgendwo günstiger!" />
    </Helmet>
  );
};

export default LpDivorceAdvoCardMeta;
